import { ReactElement } from "react";

import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

import { slashedMMDD, dd } from "helpers/date";
import { DaySummary } from "models/travelExpense";

interface DateButtonProps {
  daySummary: DaySummary;
  onClick: () => void;
}

export function DateButton({
  daySummary,
  onClick,
}: DateButtonProps): ReactElement | null {
  return (
    <Button onClick={onClick} size="small" sx={{ minWidth: "auto" }}>
      <Typography variant="button" sx={{ lineHeight: 1.2 }}>
        {slashedMMDD(daySummary.date)}
        <br />（{dd(daySummary.date)}）
      </Typography>
    </Button>
  );
}
